import { makeStyles } from 'tss-react/mui';
import { darkGrey } from "../../../../globalStyle";

const useStyles = makeStyles()((theme) => ({

  blocTitle: {
    padding: "8px 0 9px 0",
    wordBreak: "break-word",
    display: "flex",
    alignItems: "flex-start",
    lineHeight: 1
  },
  title: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.palette.black.dark
  },
  tab: {
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 700,
    minWidth: "110px",
  },
  unselectedTab: {
    color: theme.palette.grey.grey600,
    borderRight: "2px solid " + theme.palette.grey.grey200,
  },
  selectedTab: {
    color: theme.palette.primary.primary600,
    borderRight: "2px solid " + theme.palette.primary.primary600,
  },
  tabsWrapper: {
    paddingLeft: "20px",
    position: "relative",
    height: "53px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "200px",
    minHeight: "250px",

    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.primary600 + " !important",
    },
  },
  titleRed: {
    fontSize: "10px",
    fontWeight: "700",
    color: theme.palette.error.error600
  },
  titleGrey: {
    fontSize: "10px",
    fontWeight: "700",
    color: theme.palette.grey.grey700
  },
  icon: {
    width: "15px",
    marginRight: "0.5rem",
  },
  iconSmall: {
    width: "10px",
    marginRight: "0.5rem",
  },
  infoPanel: {
    backgroundColor: "white",
    borderRadius: "6px",
    flex: 1,
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    maxHeight: "285px",
    overflow: "hidden",
    padding: "10px"
  },
  scrollablePanel: {
    overflowY: "scroll",
    maxHeight: "239px",
    marginLeft: "20px",
    display: "flex",
    border: "solid 1px " + theme.palette.grey.grey100,
    padding: "5px"
  },
  typoLineWrapper: {
    /* overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    wordBreak: "break-all",
    height: "20px", */
    marginLeft: "10px"
  },
  typoLabel: {
    fontSize: "12px",
    color: "black",
    display: "inline",
  },
  typoContent: {
    fontSize: "12px",
    color: darkGrey,
    display: "inline",
  },
  typoLink: {
    fontSize: "12px",
    display: "inline",
  },
  dateTitle: {
    border: "solid 1px " + theme.palette.grey.grey100,
    borderRadius: "12px",
    width: "165px",
    margin: "2px",
    marginRight: "7px",
    display: "-webkit-box",
    padding: "4px",
    paddingLeft: "6px",
    height: "28px"
  },
  popupSubTtitle: {
    color: theme.palette.grey.grey-900,
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "140%" /* 25.2px */
  },
  greyBackground: {
    display: "flex",
    justifyContent: "left",
    fontSize: "18px",
    color: theme.palette.grey.grey700,
    flexDirection: "column",
    backgroundColor: theme.palette.grey.grey100,
    padding: "24px 20px",
    borderRadius: "4px",
    marginBottom: "10px",
    overflowY: "scroll",
    height: "65vh"
  },
  rootNoData: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.grey.grey400,
    fontWeight: 400,
    fontSize: "14px",
    width: "960px"
  },
  rootNotActivable: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.grey.grey100,
    color: theme.palette.grey.grey400,
    height: "265px",
    boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.03)",
    fontWeight: 400,
    fontSize: "14px",
  },
  notActivableText: {
    fontFamily: "'Inter'",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    color: theme.palette.grey.grey400,
    marginTop: "16px",
  }
}));

export default useStyles;
